const servicesLinks = {
  enterprise_technologies: {
    name: "ENTERPRISE TECHNOLOGIES AND SERVICES",
    links: {
      subLink1: [
        // { name: "Digital", link: "/services/digital" },

        { name: "SAP Staffing", link: "/services/sap" },
        { name: "Infor Implementation", link: "/services/infor" },

        { name: "Odoo consulting", link: "/services/odoo" },

        // { name: "AWS", link: "/services/aws" },
        // { name: "Google Cloud", link: "/services/googlecloud" },
      ],
      subLink2: [
        {
          name: "Web and App Development",
          link: "/services/applications_management",
        },
        { name: "Automation Testing ", link: "/services/testing" },

        {
          name: "Customer Relationship Management",
          link: "/services/customer_relationship_management",
        },
        // {
        //   name: " Manufacturing Execution Systems",
        //   link: "/services/manufacturing_execution_systems",
        // },
        {
          name: "Product Lifecycle Management",
          link: "/services/product_lifecycle_management",
        },
        {
          name: "Supply Chain Management",
          link: "/services/supply_chain_management",
        },
        // {
        //   name: "Environmental Social & Governance",
        //   link: "/services/environmental_social_governance",
        // },
        // { name: "IT Transformation", link: "/services/it_transformation" },
      ],
    },
  },

  Products: {
    name: "PRODUCTS",
    links: {
      subLink1: [
      
        { name: "Finsta", link: "/services/finsta" },

        {
          name: "MES (Manufacturing Execution System)",
          link: "/services/mes",
        },
      ],

      subLink2: [
        { name: "Prokraya", link: "/services/prokraya" },
        {
          name: "Office24by7",
          link: "/services/Office24by7",
        },
        // { name: "Mobillor ", link: "/services/mobillor" },
      ],
    },
  },
};
const industriesLinks = {
  industries_1: {
    links: {
      subLink1: [
        { name: "Automotive", link: "/industries/automotive" },
        { name: "Construction", link: "/industries/construction" },
        { name: "Energy", link: "/industries/energy" },

        { name: "Equipment", link: "/industries/equipment" },
        { name: "Food and Beverage", link: "/industries/food_and_beverage" },
      ],
    },
  },
  industries_2: {
    links: {
      subLink1: [
        {
          name: "Industrial Machinery and Equipment",
          link: "/industries/industrial_macinery_and_equipment",
        },
        {
          name: "Industrial Manufacturing",
          link: "/industries/industrial_manufacturing",
        },
        // {
        //   name: "Life Sciences",
        //   link: "/industries/life_sciences",
        // },
        {
          name: "High Tech and Electronics",
          link: "/industries/high_tech_and_electrinics",
        },
      ],
    },
  },
};



export { servicesLinks, industriesLinks };
